import { useState } from 'react';
import LoginOtpForm from './LoginOtp';
import SendOtpForm from './SendOtp';

const LoginForm = () => {
  const [step, setStep] = useState(0);
  const [username, setUsername] = useState('');

  return (
    <div>
      {step === 0 && <LoginOtpForm onNext={(value) => { setUsername(value); setStep(1); }} />}
      {step === 1 && <SendOtpForm username={username} setStep={setStep} />}
    </div>
  );
};

export default LoginForm;
